import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import StructuredData from '@/components/base/StructuredData';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import DownloadSection from './components/DownloadSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '澳门新葡京app官方下载-正版安全畅玩',
    description: '澳门新葡京app是澳门顶级娱乐平台官方应用，提供正版安全下载、极速流畅体验、多元游戏娱乐及专属会员福利。',
    url: 'https://www.xinpujing.mo/',
    isPartOf: {
      '@type': 'WebSite',
      name: '澳门新葡京娱乐平台',
      url: 'https://www.xinpujing.mo/',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '澳门新葡京app是否官方正版？', acceptedAnswer: { '@type': 'Answer', text: '是的，澳门新葡京app由澳门新葡京娱乐平台官方开发运营，获得澳门特别行政区政府合法授权。我们建议您仅从官方网站下载app，确保使用正版安全的应用。' } },
      { '@type': 'Question', name: '如何下载澳门新葡京app？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过本网站首页的"立即下载"按钮获取app。安卓用户可直接下载APK安装包进行安装，苹果用户可通过官方提供的iOS版本进行安装。' } },
      { '@type': 'Question', name: '澳门新葡京平台是否安全可靠？', acceptedAnswer: { '@type': 'Answer', text: '澳门新葡京平台采用银行级SSL加密技术保障数据传输安全，所有游戏均使用经国际认证的随机数生成器确保公平性。平台还设有专业安全团队24小时监控，并定期接受第三方独立审计。' } },
      { '@type': 'Question', name: '新用户注册需要哪些条件？', acceptedAnswer: { '@type': 'Answer', text: '新用户注册需年满21周岁，提供有效的手机号码和基本信息即可完成注册。注册过程完全免费，新用户还可领取专属新人礼包。' } },
      { '@type': 'Question', name: '平台支持哪些游戏类型？', acceptedAnswer: { '@type': 'Answer', text: '澳门新葡京平台提供丰富多样的游戏类型，包括老虎机、百家乐、轮盘、骰宝等桌面游戏，德州扑克等扑克竞技，真人视讯直播游戏，以及体育赛事投注等多个品类。' } },
      { '@type': 'Question', name: '充值提现是否方便快捷？', acceptedAnswer: { '@type': 'Answer', text: '平台支持多种主流支付方式，充值实时到账，提现申请审核通过后一般1-2小时内到账。会员等级越高，提现额度越大，处理速度越快。' } },
      { '@type': 'Question', name: '遇到问题如何联系客服？', acceptedAnswer: { '@type': 'Answer', text: '我们提供7×24小时全天候客户服务。您可以通过app内的在线客服功能实时咨询，或拨打客服热线+853 2888 8888。' } },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <StructuredData data={webPageSchema} />
      <StructuredData data={faqSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <ArticlesSection />
        <DownloadSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}